export enum BtnType {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  GHOST = 'ghost',
  GHOSTOUTLINE = 'ghost-outline',
  OUTLINE = 'outline',
  LINK = 'link',
  LOADING = 'loading',
  LOADINGOUTLINE = 'loading-outline',
}

export enum BtnSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export enum BtnShape {
  SQUARE = 'square',
  ROUND = 'round',
}

export const BtnTypeAll = [
  BtnType.PRIMARY,
  BtnType.DEFAULT,
  BtnType.GHOST,
  BtnType.GHOSTOUTLINE,
  BtnType.OUTLINE,
  BtnType.LINK,
  BtnType.LOADING,
  BtnType.LOADINGOUTLINE,
];

export const BtnSizeAll = [BtnSize.SM, BtnSize.MD, BtnSize.LG];

export const BtnShapeAll = [BtnShape.ROUND, BtnShape.SQUARE];

export const BtnTypeMap: Record<string, string> = {
  [BtnType.DEFAULT]: 'btn--default',
  [BtnType.PRIMARY]: 'btn--primary',
  [BtnType.GHOST]: 'btn--ghost',
  [BtnType.GHOSTOUTLINE]: 'btn--ghost-outline',
  [BtnType.OUTLINE]: 'btn--outline',
  [BtnType.LINK]: 'btn--link',
  [BtnType.LOADING]: 'btn--loading',
  [BtnType.LOADINGOUTLINE]: 'btn--loading-outline',
};

export const BtnSizeMap: Record<string, string> = {
  [BtnSize.SM]: 'btn--sm',
  [BtnSize.MD]: 'btn--md',
  [BtnSize.LG]: 'btn--lg',
};

export const BtnShapeMap: Record<string, string> = {
  [BtnShape.SQUARE]: 'btn--square',
  [BtnShape.ROUND]: 'btn--round',
};

// The following types have been added to comply with the
// new typescript strict template mode.
// When using the enum type as an input definition
// e.g.
// @Input() size: BtnSize
//
// <nibtravel-button size="md"></nibtravel-button>
//
// The newer version of typescript strictly requires the enum
// value to be provided, meaning it only accepts BtnSize.<Size>
// where it would previously accept '<size>'
// The following definition will accept both
export type BtnSizeInput = 'sm' | 'md' | 'lg';
export type BtnShapeInput = 'square' | 'round';
export type BtnTypeInput =
  | 'default'
  | 'primary'
  | 'ghost'
  | 'ghost-outline'
  | 'outline'
  | 'link'
  | 'loading'
  | 'loading-outline';
